import "../../css/GlobalStyles.css";
import { useCallback } from "react";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "../Containers/PopupModalContainer";
import RectangleButton from "../Buttons/RectangleButton";
import { Colors } from "../../utils/colors";
import { useDispatch, useSelector } from "react-redux";
import MarkitLogoBlue from "../../assets/MarkitLogoBlue.png";
import {
  getNotificationState,
  notificationActions,
} from "../../redux/slices/notificationSlice";
import { isDesktop } from "react-device-detect";

export const AccountMismatchModal = () => {
  const { accountMismatchModal } = useSelector(getNotificationState);
  const dispatch = useDispatch();

  const closeOnPress = useCallback(() => {
    window.location.reload();
    dispatch(notificationActions.setAccountMismatchModal(false));
  }, [dispatch]);

  return accountMismatchModal ? (
    <PopupModalContainer
      headerComp={
        <div className="ColumnNormal" style={{ gap: 14, padding: 4 }}>
          <div>
            <img
              style={{ height: 24, width: "auto", objectFit: "cover" }}
              src={MarkitLogoBlue}
              alt={"markitLogoBlue"}
            />
          </div>
          <div className="ColumnNormal" style={{ gap: 7 }}>
            <span style={{ fontSize: 20, fontWeight: 500 }}>
              You switched accounts
            </span>
            <span className="bodySubtext">
              Looks like you signed into a different account on another tab.
              Refresh this page to sync things up.
              <br />
              <br />
              You can switch accounts at anytime by clicking the profile button
              in the top right corner.
            </span>
          </div>
        </div>
      }
      valueComp={
        <div className="ColumnNormal" style={{ gap: 10, alignItems: "center" }}>
          <RectangleButton
            buttonLabel={
              <span style={{ color: Colors.WHITE, fontSize: 14 }}>Refresh</span>
            }
            onPress={closeOnPress}
            altColor={Colors.BLACK}
            altPaddingVert={16}
            altPaddingHorz={12}
          />
        </div>
      }
      closeModal={closeOnPress}
      noExit
      modalContentWidth={isDesktop ? undefined : PopupModalContainerWidth.SMALL}
    />
  ) : null;
};
